define("shared/components/shared/ui/ember-drop", ["exports", "@ember/component", "@ember/template-factory", "@ember-decorators/component", "@ember/object", "@ember/runloop", "@ember/utils"], function (_exports, _component, _templateFactory, _component2, _object, _runloop, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _class2;

  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember-decorators/component",0,"@ember/object",0,"@ember/component",0,"@ember/runloop",0,"@ember/utils",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{yield (hash
      closeAction=(action "closeAction")
      openAction=(action "openAction")
    )
  }}
  
  */
  {
    "id": "ClBF+xuE",
    "block": "[[[18,1,[[28,[37,1],null,[[\"closeAction\",\"openAction\"],[[28,[37,2],[[30,0],\"closeAction\"],null],[28,[37,2],[[30,0],\"openAction\"],null]]]]]],[1,\"\\n\"]],[\"&default\"],false,[\"yield\",\"hash\",\"action\"]]",
    "moduleName": "shared/components/shared/ui/ember-drop.hbs",
    "isStrictMode": false
  });

  let EmberDrop = (_dec = (0, _component2.classNames)('shared-ember-drop'), _dec2 = (0, _object.computed)('target'), _dec(_class = (_class2 = class EmberDrop extends _component.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "beforeClose", undefined);

      _defineProperty(this, "blurDelay", undefined);

      _defineProperty(this, "classes", undefined);

      _defineProperty(this, "closeDelay", undefined);

      _defineProperty(this, "constrainToScrollParent", undefined);

      _defineProperty(this, "constrainToWindow", undefined);

      _defineProperty(this, "content", undefined);

      _defineProperty(this, "contentSelector", undefined);

      _defineProperty(this, "focusDelay", undefined);

      _defineProperty(this, "hoverCloseDelay", undefined);

      _defineProperty(this, "hoverOpenDelay", undefined);

      _defineProperty(this, "onOpen", undefined);

      _defineProperty(this, "openDelay", undefined);

      _defineProperty(this, "openOn", undefined);

      _defineProperty(this, "openOnInsert", false);

      _defineProperty(this, "position", undefined);

      _defineProperty(this, "remove", undefined);

      _defineProperty(this, "tetherOptions", undefined);

      _defineProperty(this, "openOnInsertDelay", 100);
    }

    didInsertElement() {
      super.didInsertElement(...arguments);
      this.addDrop();

      if (this.openOnInsert) {
        _runloop.run.later(() => this.openDrop(this._drop), this.openOnInsertDelay);
      }
    }

    willDestroyElement() {
      super.willDestroyElement(...arguments);
      const {
        _drop,
        element
      } = this;

      _runloop.run.schedule('render', () => {
        this.removeElement(element);
        this.removeDrop(_drop);
      });
    }

    didRender() {
      super.didRender(...arguments);
      this.positionDrop();
    }

    didUpdateAttrs() {
      super.didUpdateAttrs();
      this.removeDrop(this._drop);
      this.addDrop();
    }

    closeAction() {
      this.closeDrop(this._drop);
    }

    openAction() {
      this.openDrop(this._drop);
    }

    positionDrop() {
      if (this._drop) {
        this._drop.position();
      }
    }

    addDrop() {
      if (this._dropTarget) {
        this._drop = new Drop(this._dropOptions());

        if (this.onOpen) {
          this._drop.on('open', () => this.onOpen(), this);
        }

        if (this.setCloseAction) {
          this.setCloseAction(this.closeDrop, this._drop);
        }

        if (this.setOpenAction) {
          this.setOpenAction(this.openDrop, this._drop);
        }
      }
    }

    removeDrop(drop) {
      if (drop) {
        drop.destroy();
      }
    }

    openDrop(dropInstance) {
      if (dropInstance) {
        dropInstance.open();
      }
    }

    closeDrop(dropInstance) {
      if (dropInstance) {
        dropInstance.close();
      }
    }

    removeElement(element) {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }

    get _dropTarget() {
      let {
        target
      } = this;

      if (target && target.element) {
        target = target.element;
      }

      return target;
    }

    _beforeClose() {// we dont' really listen for "beforeClose" action, and it was causing problems
    }

    _dropOptions() {
      const self = this;
      const options = {
        element: this.element,
        target: document.querySelector(this._dropTarget),

        beforeClose() {
          self._beforeClose();
        }

      };
      const {
        contentSelector
      } = this;
      const {
        content
      } = this;

      if (!(0, _utils.isNone)(contentSelector)) {
        options.content = document.querySelector(contentSelector);
      } else if (!(0, _utils.isNone)(content)) {
        options.content = this.content;
      }

      if (!options.content && this._drop) {
        var _this$_drop$options;

        options.content = (_this$_drop$options = this._drop.options) === null || _this$_drop$options === void 0 ? void 0 : _this$_drop$options.content;
      }

      ['blurDelay', 'classes', 'closeDelay', 'constrainToScrollParent', 'constrainToWindow', 'focusDelay', 'hoverCloseDelay', 'hoverOpenDelay', 'openDelay', 'openOn', 'position', 'remove', 'tetherOptions'].forEach(optionName => {
        const optionValue = this.get(optionName);

        if (optionValue !== undefined) {
          options[optionName] = optionValue;
        }
      });
      return options;
    }

  }, (_applyDecoratedDescriptor(_class2.prototype, "closeAction", [_object.action], Object.getOwnPropertyDescriptor(_class2.prototype, "closeAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "openAction", [_object.action], Object.getOwnPropertyDescriptor(_class2.prototype, "openAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_dropTarget", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "_dropTarget"), _class2.prototype)), _class2)) || _class);
  _exports.default = EmberDrop;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmberDrop);
});